<!--
 * @Author: your name
 * @Date: 2020-11-19 18:09:36
 * @LastEditTime: 2021-11-11 15:46:30
 * @LastEditors: zhangcx33595
 * @Description: In User Settings Edit
 * @FilePath: \openplat-web\src\gtn\components\index\bottomFooter.vue
-->
<template>
  <div>
    <div class="footer-wrapper">
      <div class="footer clearfix">
        <div class="fb-l">
          <!-- <div class="img"></div> -->
          <div class="col client">
            <h4>24小时客服</h4>
            <ul>
              <li>电话：0571-26691719</li>
              <li>
                <a href="mailto:gtn@hundsun.com">Email : gtn@hundsun.com</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="fb-r clearfix">
          <div class="col">
            <h4>服务与支持</h4>
            <ul>
              <li>
                <a href="/openplat-doc/gtnDoc?docId=97078ddf0cde4c77ab89dbbc5e3c1efa" target="_blank">新人指引</a>
              </li>
              <li>
                <a href="/openplat-doc/gtnDoc?docId=97078ddf0cde4c77ab89dbbc5e3c1efa" target="_blank">开发者指引</a>
              </li>
              <li>
                <a href="https://www.hs.net/news.html?type_id=8" target="_blank">服务公告</a>
              </li>
              <li>
                <a href="https://www.hs.net/openplat-doc/faqFDoc" target="_blank">常见问题</a>
              </li>
            </ul>
          </div>
          <div class="col">
            <h4>管理台</h4>
            <ul>
              <li>
                <a href="https://www.hs.net/iuc/register" target="_blank">账户注册</a>
              </li>
              <li>
                <a href="https://www.hs.net/iuc/resetPwd" target="_blank">忘记密码</a>
              </li>
              <li>
                <a href="https://www.hs.net/cloud-console/" target="_blank">管理台</a>
              </li>
              <!-- <li>
                <a href="https://www.hs.net/console/account_management.html" target="_blank">充值付款</a>
              </li>-->
              <li>
                <a href="https://www.hs.net/cloud-console/trade/myContract" target="_blank">合同申请</a>
              </li>
              <li>
                <a href="https://www.hs.net/cloud-console/trade/myInvoice" target="_blank">发票申请</a>
              </li>
            </ul>
          </div>
          <div class="col">
            <h4>资源与社区</h4>
            <ul>
              <li>
                <a href="https://www.hs.net/openplat-doc/gtnDoc?docId=97078ddf0cde4c77ab89dbbc5e3c1efa" target="_blank">文档中心</a>
              </li>
              <li>
                <a
                  href="https://www.hs.net/com.hundsun.openplat.front/cloud/open/tool.html"
                  target="_blank"
                >API测试工具</a>
              </li>
              <li>
                <a href="/GtnMarket.html" target="_blank">云市场</a>
              </li>
            </ul>
          </div>
          <div class="col">
            <h4>关于LIGHT云</h4>
            <ul>
              <li>
                <a href="/cloud/open/activity/hundsunHistory.html" target="_blank">了解LIGHT云</a>
              </li>
              <li>
                <a href="/cloud/open/activity/hundsunHistory.html?n=1" target="_blank">发展历程</a>
              </li>
              <li>
                <a href="/cloud/open/activity/hundsunAdvisory.html" target="_blank">新闻资讯</a>
              </li>
              <li>
                <a href="/cloud/open/activity/hundsunHistory.html?n=4" target="_blank">联系我们</a>
              </li>
            </ul>
          </div>
          <div class="col">
            <h4>关注LIGHT云</h4>
            <img src="~@/assets/index/footer-code.jpg" />
          </div>
        </div>
      </div>
      <div style="width:100%;background:#C4C4C4;height:1px;margin-top:20px"></div>
      <div class="footer-bottom">
        <p style="padding-bottom: 16px">
          <a href="http://www.hundsun.com/">恒生电子&nbsp;|</a>
          <a href="http://www.hsyunyi.com/">&nbsp;云毅网络 &nbsp;|</a>
          <!-- <a href="http://www.yun-in.com/">&nbsp;云英网络 &nbsp;| </a> -->
          <a href="http://www.gildata.com/">&nbsp;恒生聚源 &nbsp;|</a>
          <a href="https://www.isimu123.com/">&nbsp;i私募 &nbsp;|</a>
          <!-- <a href="http://www.hzyunlian.com/">&nbsp;云连网络 &nbsp;|</a> -->
          <!-- <a href="http://www.winner123.cn/">&nbsp;云赢网络 &nbsp;|</a> -->
          <!-- <a href="https://www.51zhigu.com/">&nbsp;智股网络 &nbsp;| </a> -->
          <a href="http://one2rich.cn/">&nbsp;商智神州 &nbsp;|</a>
          <a href="https://www.5ibazhuayu.com.cn/">&nbsp;云永网络 &nbsp;|</a>
          <!--<a href="http://www.hsztou.com/">&nbsp;证投网络 &nbsp;| </a>-->
          <!-- <a href="http://www.hsztou.com/">&nbsp;证投网络&nbsp;|</a> -->
          <a href="http://www.hundsun.com.hk/">&nbsp;恒云科技</a>
        </p>
        <p>
          ©2021&nbsp;&nbsp;hs.net 版权所有
          <span style="margin-left: 10px">
            ICP备案号：
            <a href="http://beian.miit.gov.cn/">浙ICP备09092082号-30</a>
          </span>
          <span style="margin-left: 10px">ICP经营许可证：浙B2-20170536</span>
        </p>
        <p class="beian" style="padding-bottom: 28px">
          <i class="img"></i>
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010802004704"
          >浙公网安备 33010802004704号</a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "BottomFooter",
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
.footer-wrapper {
  width: 100%;
  background: #f3f3f3;
  height: 100%;
}

.footer-wrapper .footer {
  width: 1200px;
  margin: 0 auto;
  padding-top: 50px;
  background: #f3f3f3;
}

.footer-wrapper .footer .fb-l {
  float: left;
  height: 210px;
  margin-right: 10px;
  //border-right: 1px solid rgba(255, 255, 255, 0.2);
}

.footer-wrapper .footer .fb-l .img {
  width: 40px;
  height: 40px;
  background: url("~@/assets/NSQspeed/foot-khfw1.png") no-repeat left center;
  display: inline-block;
  vertical-align: top;
  top: -4px;
  position: relative;
}

.footer-wrapper .footer .fb-l .client {
  margin: 0 50px 0 20px;
}

.footer-wrapper .footer .fb-l .col {
  display: inline-block;
  vertical-align: top;
}

.footer-wrapper .footer .fb-l .col h4 {
  font-family: PingFangSC-Medium;
  font-size: 14px;
  color: #000;
  letter-spacing: 0;
  line-height: 18px;
  font-weight: 600;
  text-align: left;
  margin-bottom: 20px;
}

.footer-wrapper .footer .fb-l .col ul li {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #666;
  letter-spacing: 0;
  line-height: 30px;
  font-weight: 400;
  margin-bottom: 14px;
  text-align: left;
}

.footer-wrapper .footer .fb-l .col ul li a {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #666;
  letter-spacing: 0;
  line-height: 30px;
  font-weight: 400;
  text-align: left;
}

.footer-wrapper .footer .fb-l .col ul li a:hover {
  color: #3060ff;
  opacity: 1;
}

// .footer-wrapper .footer .fb-l .col ul li.qrcode {
//   opacity: 1;
//   width: 100px;
//   height: 100px;
//   background: url("/open/images/indexNew/index-qrcode.png") no-repeat center
//     center;
// }

.footer-wrapper .footer .fb-r .col {
  display: inline-block;
  vertical-align: top;
}

.footer-wrapper .footer .fb-r .col h4 {
  font-family: PingFangSC-Medium;
  font-size: 14px;
  color: #000;
  letter-spacing: 0;
  line-height: 18px;
  font-weight: 600;
  margin-bottom: 20px;
}

.footer-wrapper .footer .fb-r .col ul li {
  margin-bottom: 14px;
  font-size: 12px;
  text-align: left;
  color: rgba(255, 255, 255, 0.5);
}

.footer-wrapper .footer .fb-r .col ul li a {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #666;
  letter-spacing: 0;
  line-height: 30px;
  font-weight: 400;
}

.footer-wrapper .footer .fb-r .col ul li a:hover {
  color: #3060ff;
  opacity: 1;
}

// .footer-wrapper .footer .fb-r .col ul li.qrcode {
//   opacity: 1;
//   width: 100px;
//   height: 100px;
//   background: url("/open/images/indexNew/index-qrcode.png") no-repeat center
//     center;
// }

.footer-wrapper .footer .fb-r ul li:hover {
  opacity: 1;
}

.footer-wrapper .footer .fb-r .col {
  margin-right: 122px;
  &:last-child {
    margin-right: 0;
  }
}

// .footer-wrapper .footer .fb-r .col:nth-child(2) {
//   //margin-left: 96px;
// }

// .footer-wrapper .footer .fb-r .col:nth-child(3) {
//   margin-left: 96px;
// }

// .footer-wrapper .footer .fb-r .col:nth-child(4) {
//   margin-left: 80px;
// }

.footer-wrapper .footer .fb-r .col:last-child {
  float: right;
  img {
    width: 88px;
    height: 87px;
    margin-right: 25px;
  }
}

.footer-wrapper .footer-bottom {
  margin-top: 35px;
}

.footer-wrapper .footer-bottom p {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #666;
  font-weight: 400;
  text-align: center;
  padding-bottom: 8px;
  &:first-child {
    font-size: 14px;
  }
}
.footer-wrapper .footer-bottom p a {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #666;
  text-align: center;
  font-weight: 400;
}

.footer-wrapper .footer-bottom .beian {
  opacity: 1;
}

.footer-wrapper .footer-bottom .beian .img {
  background: url("~@/assets/NSQspeed/police.png") center center no-repeat;
  width: 20px;
  height: 20px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}

.footer-wrapper .footer-bottom .beian a {
  text-align: center;

  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #666;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/gtn/components/index/bottomFooter.vue